import React from "react";
import { isUndefined } from "lodash";

import "./payment-method-card.css";
import backtick from "../../pages/dashboard/assets/backtick.svg";

export const PaymentMethodCard = ({ name, balance, icon }) => {
  return (
    <div className="payment-method-card">
      <div className="icon">
        <img src={icon} alt="wallet-icon" />
      </div>
      <div className="wallet-details ml-4">
        <p className="name">{name}</p>

        {!isUndefined(balance) && <p className="balance">Balance: {balance}</p>}
      </div>
      <img src={backtick} className="select-icon" alt="select-icon" />
    </div>
  );
};
